import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "@/components/Reveal";
import { FAQS } from "@/data/content";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Reveal><Overline>FAQ</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-4xl sm:text-5xl font-semibold font-heading tracking-tight leading-tight text-slate-900">
              Questions, answered.
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-slate-200">
                <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-slate-900 hover:no-underline py-6">{f.q}</AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-slate-600 leading-relaxed pb-6 pr-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
